<script>
	import { Row, Col } from "sveltestrap";
	import CustomInput from "../../../components/CustomInput/CustomInput.svelte";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import { debounce } from "lodash";
	import DropdownCheckbox from "../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import { lookupToOptions } from "../../../utils/misc";
	import { navigate } from "svelte-routing";
	import { initPage } from "src/store/store";
	import { convertDateOnly } from "src/services/helpers";

	export let changeBacklogParams = () => {};
	export let lookups;
	export let jobLookups;
	export let backlogParams;

	let vehiclePlateNo = "";
	let isOpen = -1;

	function toggleDropdown(idx) {
		isOpen = isOpen === idx ? -1 : idx;
	}

	function handleChange(value) {
		changeBacklogParams({ ...value, pageNumber: 1, page: 1 });
		initPage.set(1);
	}

	function resetFilter() {
		navigate("/jobs?tab=3");
		changeBacklogParams("");
	}

	$: options = {
		vehicleSubstatusIds: lookupToOptions(lookups.vehicleStatuses),
		presetTaskIds: lookupToOptions(lookups.presetTasks),
		priorities: lookupToOptions(lookups.taskPriorities),
		regionIds: lookupToOptions(lookups.regions),
		estateIds: lookupToOptions(jobLookups.estateLookups),
	};

	$: if (backlogParams.priorities) {
		options.priorities = options.priorities.map((priority) => ({
			...priority,
			selected: backlogParams.priorities.includes(priority.id),
		}));
	} else {
		options.priorities = options.priorities.map((priority) => ({
			...priority,
			selected: false,
		}));
	}

	$: if (backlogParams.regionIds) {
		options.regionIds = options.regionIds.map((region) => ({
			...region,
			selected: backlogParams.regionIds.includes(region.id),
		}));
	} else {
		options.regionIds = options.regionIds.map((region) => ({
			...region,
			selected: false,
		}));
	}

	$: if (backlogParams.estateIds) {
		options.estateIds = options.estateIds.map((estate) => ({
			...estate,
			selected: backlogParams.estateIds.includes(estate.id)
		}));
	} else {
		options.estateIds = options.estateIds.map((estate) => ({
			...estate,
			selected: false
		}));
	}

	$: if (backlogParams.vehicleSubstatusIds) {
		options.vehicleSubstatusIds = options.vehicleSubstatusIds.map(
			(vehicleSubstatus) => ({
				...vehicleSubstatus,
				selected: backlogParams.vehicleSubstatusIds.includes(
					vehicleSubstatus.id
				),
			})
		);
	} else {
		options.vehicleSubstatusIds = options.vehicleSubstatusIds.map(
			(vehicleSubstatus) => ({
				...vehicleSubstatus,
				selected: false,
			})
		);
	}

	$: if (backlogParams.presetTaskIds) {
		options.presetTaskIds = options.presetTaskIds.map((presetTask) => ({
			...presetTask,
			selected: backlogParams.presetTaskIds.includes(presetTask.id),
		}));
	} else {
		options.presetTaskIds = options.presetTaskIds.map((presetTask) => ({
			...presetTask,
			selected: false,
		}));
	}

	$: if (backlogParams.vehiclePlateNo) {
		vehiclePlateNo = backlogParams.vehiclePlateNo;
	}

	const debouncedInput = debounce((e) => handleChange(e), 1000);
</script>

<Row>
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row>
					<Col xs={4}>
						<CustomInput
							placeholder="Vehicle no."
							bind:value={vehiclePlateNo}
							search
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="vehiclePlateNo"
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={2} style="position:relative">
				<Row>
					<Col
						class="d-flex justify-content-end"
						style="position:absolute"
					>
						<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
						<span
							class="on-surface-variant"
							style="text-align: end; white-space: nowrap"
							>Last updated {convertDateOnly(
								new Date(),
								"MMM D, h:mm A"
							) || ""}</span
						>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row>
			<Col xs={10}>
				<Row class="mb-3 gx-2">
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Car Statuses"
							options={options.vehicleSubstatusIds}
							refetch={handleChange}
							id="vehicleSubstatusIds"
							isOpen={isOpen === 1}
							toggle={() => toggleDropdown(1)}
						/>
					</Col>
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Tasks"
							options={options.presetTaskIds}
							refetch={handleChange}
							id="presetTaskIds"
							isOpen={isOpen === 2}
							toggle={() => toggleDropdown(2)}
						/>
					</Col>

					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Priorities"
							options={options.priorities}
							refetch={handleChange}
							id="priorities"
							isOpen={isOpen === 3}
							toggle={() => toggleDropdown(3)}
						/>
					</Col>
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Regions"
							options={options.regionIds}
							refetch={handleChange}
							id="regionIds"
							isOpen={isOpen === 4}
							toggle={() => toggleDropdown(4)}
						/>
					</Col>
					<Col xs={2}>
						<DropdownCheckbox
							categoryName="Estates"
							options={options.estateIds}
							refetch={handleChange}
							id="estateIds"
							isOpen={isOpen === 5}
							toggle={() => toggleDropdown(5)}
						/>
					</Col>
					<Col xs={2}>
						<CustomButton
							style="border-color: transparent; font-weight: bold"
							buttonText="Clear filters"
							onClick={resetFilter}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</Col>
</Row>
